







import { Formatter } from "@goodless/utilities"
import { ComponentWithProperties, NavigationMixin } from '@simonbackx/vue-app-navigation';
import { Component, Mixins,Prop, Watch } from "vue-property-decorator";

import DateSelectionView from './DateSelectionView.vue';

@Component
export default class DateSelection extends Mixins(NavigationMixin) {
    @Prop({ default: null })
    value: Date | null

    @Prop({ default: "" })
    placeholder: string

    @Prop({ default: 12 })
    defaultHour: number

    @Prop({ default: null })
    minDate: Date | null

    @Prop({ default: null })
    maxDate: Date | null

    get dateText() {
        if (!this.value) {
            return this.placeholder
        }
        return Formatter.date(this.value)
    }

    @Watch('maxDate')
    onMaxChanged(maxDate: Date | null) {
        if (!this.maxDate || !this.value) {
            return
        }
        if (this.value > this.maxDate) {
            const d = new Date(this.maxDate.getTime())
            if (this.value) {
                d.setHours(this.value.getHours(), this.value.getMinutes(), 0, 0)
            } else {
                d.setHours(this.defaultHour, 0, 0, 0)
            }

            if (this.minDate && d < this.minDate) {
                this.$emit("input", null)
            } else {
                this.$emit("input", d)
            }
        }
    }

    @Watch('minDate')
    onMinChanged(minDate: Date | null) {
        if (!this.minDate || !this.value) {
            return
        }
        if (this.value < this.minDate) {
            const d = new Date(this.minDate.getTime())
            if (this.value) {
                d.setHours(this.value.getHours(), this.value.getMinutes(), 0, 0)
            } else {
                d.setHours(this.defaultHour, 0, 0, 0)
            }

            if (this.maxDate && d > this.maxDate) {
                this.$emit("input", null)
            } else {
                this.$emit("input", d)
            }
        }
    }

    openContextMenu(event) {
        const el = this.$el as HTMLElement;
        const displayedComponent = new ComponentWithProperties(DateSelectionView, {
            x: el.getBoundingClientRect().left + el.offsetWidth - 300,
            y: el.getBoundingClientRect().top + el.offsetHeight,
            selectedDay: this.value,
            minDate: this.minDate,
            maxDate: this.maxDate,
            setDate: (value: Date) => {
                const d = new Date(value.getTime())
                if (this.value) {
                    d.setHours(this.value.getHours(), this.value.getMinutes(), 0, 0)
                } else {
                    d.setHours(this.defaultHour, 0, 0, 0)
                }
                this.$emit("input", d)
            }
        });
        this.present(displayedComponent.setDisplayStyle("overlay"));
    }
}
